import { moduleProviderFactory } from "mrb/core";
import {
    LoadioArtistList,
    LoadioArtistPreview,
    LoadioAlbumTrackList,
    LoadioStoreHomeSectionList,
    LoadioStoreFeaturedSection,
    LoadioConfiguration,
    LoadioContentProfileList,
    LoadioContentProfileEdit,
    LoadioContentProfileArtists,
    LoadioDeviceList,
} from "administration/loadio/pages";
import {
    LoadioArtistListRouteStore,
    LoadioArtistPreviewRouteStore,
    LoadioAlbumTrackListRouteStore,
    LoadioStoreHomeSectionListRouteStore,
    LoadioStoreFeaturedSectionRouteStore,
    LoadioConfigurationRouteStore,
    LoadioContentProfileListRouteStore,
    LoadioContentProfileEditRouteStore,
    LoadioContentProfileArtistsRouteStore,
    LoadioDeviceListRouteStore,
} from "administration/loadio/stores";

(function () {
    moduleProviderFactory.module("administration").register({
        name: "Loadio",
        routes: [
            {
                name: "master.administration.loadio",
                pattern: "/loadio",
                beforeEnter: (fromState, toState, routerStore) => {
                    const { userStore } = routerStore.rootStore;
                    if (!userStore.isAdministrator) {
                        return Promise.reject(routerStore.notFoundState);
                    }
                },
                children: [
                    {
                        name: "master.administration.loadio.artist.list",
                        pattern: "/artists",
                        component: LoadioArtistList,
                        store: LoadioArtistListRouteStore,
                        data: {
                            title: "ADMINISTRATION.LOADIO.LIST.TITLE",
                        },
                    },
                    {
                        name: "master.administration.loadio.artist.preview",
                        pattern: "/artist/:id",
                        component: LoadioArtistPreview,
                        store: LoadioArtistPreviewRouteStore,
                    },
                    {
                        name: "master.administration.loadio.artist.album.tracks",
                        pattern: "/album/:id/tracks",
                        component: LoadioAlbumTrackList,
                        store: LoadioAlbumTrackListRouteStore,
                    },
                    {
                        name: "master.administration.loadio.store-sections",
                        pattern: "/sections",
                        store: LoadioStoreHomeSectionListRouteStore,
                        component: LoadioStoreHomeSectionList,
                        data: {
                            title: "Home Screen Sections",
                        },
                    },
                    {
                        name: "master.administration.loadio.store-featured-section",
                        pattern: "/featured-section",
                        store: LoadioStoreFeaturedSectionRouteStore,
                        component: LoadioStoreFeaturedSection,
                    },
                    {
                        name: "master.administration.loadio.configuration",
                        pattern: "/configuration",
                        store: LoadioConfigurationRouteStore,
                        component: LoadioConfiguration,
                        data: {
                            title: "ADMINISTRATION.LOADIO.CONFIGURATION.TITLE",
                        },
                    },
                ],
            },
            {
                name: "master.administration.loadio-dashboard",
                pattern: "/loadio-dashboard",
                beforeEnter: (fromState, toState, routerStore) => {
                    const { userStore } = routerStore.rootStore;
                    if (!userStore.isAdministrator && !userStore.isLoadio) {
                        return Promise.reject(routerStore.notFoundState);
                    }
                },
                children: [
                    {
                        name: "master.administration.loadio-dashboard.profile.list",
                        pattern: "/content-profiles",
                        component: LoadioContentProfileList,
                        store: LoadioContentProfileListRouteStore,
                        data: {
                            title: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.TITLE",
                        },
                    },
                    {
                        name: "master.administration.loadio-dashboard.profile.create",
                        pattern: "/content-profiles/create",
                        component: LoadioContentProfileEdit,
                        store: LoadioContentProfileEditRouteStore,
                    },
                    {
                        name: "master.administration.loadio-dashboard.profile.edit",
                        pattern: "/content-profiles/:id/edit",
                        component: LoadioContentProfileEdit,
                        store: LoadioContentProfileEditRouteStore,
                    },
                    {
                        name: "master.administration.loadio-dashboard.profile.artists",
                        pattern: "/content-profiles/:id/artists",
                        component: LoadioContentProfileArtists,
                        store: LoadioContentProfileArtistsRouteStore,
                        data: {
                            title: "ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_ARTISTS.TITLE",
                        },
                    },
                    {
                        name: "master.administration.loadio-dashboard.device.list",
                        pattern: "/devices",
                        component: LoadioDeviceList,
                        store: LoadioDeviceListRouteStore,
                        data: {
                            title: "ADMINISTRATION.LOADIO_DASHBOARD.DEVICES.TITLE",
                        },
                    },
                ],
            },
        ],
        menu: [
            {
                title: "ADMINISTRATION.MENU.LOADIO",
                order: 8,
                icon: "loadio",
                subMenu: [
                    {
                        title: "ADMINISTRATION.MENU.LOADIO_STORE_HOME_SCREEN",
                        order: 1,
                        route: "master.administration.loadio.store-sections",
                    },
                    {
                        title: "ADMINISTRATION.MENU.LOADIO_STORE_FEATURED_SECTION",
                        order: 2,
                        route: "master.administration.loadio.store-featured-section",
                    },
                    {
                        title: "ADMINISTRATION.MENU.LOADIO_ARTIST_LIST",
                        order: 3,
                        route: "master.administration.loadio.artist.list",
                    },
                    {
                        title: "ADMINISTRATION.MENU.LOADIO_CONFIGURATION",
                        order: 4,
                        route: "master.administration.loadio.configuration",
                    },
                ],
            },
            {
                title: "ADMINISTRATION.MENU.LOADIO_DASHBOARD",
                order: 9,
                icon: "loadio",
                subMenu: [
                    {
                        title: "ADMINISTRATION.MENU.LOADIO_DASHBOARD_CONTENT_PROFILES",
                        order: 1,
                        route: "master.administration.loadio-dashboard.profile.list",
                    },
                    {
                        title: "ADMINISTRATION.MENU.LOADIO_DASHBOARD_DEVICE_ASSIGNMENT",
                        order: 2,
                        route: "master.administration.loadio-dashboard.device.list",
                    },
                ],
            },
        ],
    });
})();
